module.exports = __webpack_public_path__ + "img/img2.afecc4b4.jpg";